import classNames from 'classnames';
import { useCallback, useState } from 'react';
import { generatePath, useHistory } from 'react-router';
import { FormattedMessage } from 'react-intl';

import IconButton from '../../components/buttons/IconButton';
import { InlineLink } from '../../components/typography';
import { QuoteBadge as Badge } from '../../app/enums/QuoteBadge';
import routes from '../../app/routes';
import { QuoteConversionDialog } from '../../dialogs/QuoteConversion';
import { useQuoteBadgeStyles } from './QuoteBadge.styles';

export function QuoteBadge({ data }) {
  const { styles } = useQuoteBadgeStyles();
  const [isConversionDialogOpen, setConversionDialogOpen] = useState(false);
  const { push } = useHistory();
  const { badge, referenceNo } = data || {};

  const openQuoteForm = useCallback(
    event => {
      event.stopPropagation();
      push(
        generatePath(routes.quoting.editQuote, {
          referenceNo,
        })
      );
    },
    [push, referenceNo]
  );

  const handleConversionOk = useCallback(() => {
    push(`/book/new-shipment/from-address?referenceNo=${referenceNo}`);
  }, [push, referenceNo]);

  const bookBtnClicked = event => {
    event.stopPropagation();
    setConversionDialogOpen(true);
  };

  const onBadgeClick = event => {
    event.stopPropagation();
  };

  const badgeModifierStyles = {
    [Badge.BOOKED]: styles.badgeBooked,
    [Badge.EXPIRED]: styles.badgeExpired,
  };

  return (
    <>
      <div className={styles.quoteBadgeSection}>
        <InlineLink className={styles.inlineLink} onClick={openQuoteForm}>
          <FormattedMessage id="monitor.quote.reuse" />
        </InlineLink>
        {![Badge.INCOMPLETE, Badge.BOOK].includes(badge) ? (
          <span
            onClick={onBadgeClick}
            className={classNames(styles.badge, badgeModifierStyles[badge])}
          >
            {Badge[badge]}
          </span>
        ) : (
          <IconButton
            className={styles.iconButton}
            icon="chevron-circle-right"
            onClick={bookBtnClicked}
          >
            <FormattedMessage id="monitor.quote.book" />
          </IconButton>
        )}
      </div>

      <QuoteConversionDialog
        isOpen={isConversionDialogOpen}
        onOk={handleConversionOk}
        onCancel={() => setConversionDialogOpen(false)}
      />
    </>
  );
}
